import script from "./PatientPortrait.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientPortrait.vue?vue&type=script&setup=true&lang=js"

import "./PatientPortrait.vue?vue&type=style&index=0&id=8e524b76&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e524b76"]])

export default __exports__